if (!customElements.get('share-social')) {
  customElements.define(
    'share-social',
    class ShareSocial extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.share-social__toggle');
        this.panel = this.querySelector('.share-social__panel');
        this.copyButton = this.querySelector('.share-social__copy');
        this.message = this.querySelector('.share-social__message');

        if (!this.toggleButton || !this.panel) return;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onCopyClick = this.onCopyClick.bind(this);

        this.toggleButton.addEventListener('click', this.onToggleClick);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
        if (this.copyButton) this.copyButton.addEventListener('click', this.onCopyClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      get shareUrl() {
        return this.dataset.shareUrl || window.location.href;
      }

      get shareTitle() {
        return this.dataset.shareTitle || document.title;
      }

      // Só usa o menu nativo em dispositivos de toque: o Safari (macOS) e o Edge
      // (Windows) suportam navigator.share no desktop, onde queremos o painel.
      get useNativeShare() {
        return (
          typeof navigator.share === 'function' &&
          window.matchMedia('(pointer: coarse)').matches
        );
      }

      onToggleClick() {
        if (this.useNativeShare) {
          navigator
            .share({ url: this.shareUrl, title: this.shareTitle })
            .catch(() => {
              // Cancelar a folha de partilha rejeita a promessa (AbortError) — ignorar.
            });
          return;
        }
        this.togglePanel(this.panel.hasAttribute('hidden'));
      }

      togglePanel(open) {
        if (open) {
          this.panel.removeAttribute('hidden');
        } else {
          this.panel.setAttribute('hidden', '');
          this.showMessage('');
        }
        this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      onDocumentClick(event) {
        if (!this.contains(event.target) && !this.panel.hasAttribute('hidden')) {
          this.togglePanel(false);
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape' && !this.panel.hasAttribute('hidden')) {
          this.togglePanel(false);
          this.toggleButton.focus();
        }
      }

      showMessage(text) {
        if (this.message) this.message.textContent = text;
      }

      onCopyClick() {
        const copiedMessage = this.dataset.copiedMessage || 'Ligação copiada!';
        const errorMessage = this.dataset.errorMessage;
        if (!navigator.clipboard?.writeText) {
          this.showMessage(errorMessage);
          return;
        }
        navigator.clipboard
          .writeText(this.shareUrl)
          .then(() => this.showMessage(copiedMessage))
          .catch(() => this.showMessage(errorMessage));
      }

      // Chamado pelo product-info.js quando a variante muda (troca de URL via AJAX,
      // sem recarregar a página). Actualiza o URL cru e reconstrói os links do painel,
      // que foram renderizados em Liquid com o URL da variante inicial.
      updateUrl(url) {
        this.dataset.shareUrl = url;

        const encodedUrl = encodeURIComponent(url);
        const encodedTitle = encodeURIComponent(this.shareTitle);

        const whatsapp = this.querySelector('[data-share-channel="whatsapp"]');
        if (whatsapp) whatsapp.href = `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`;

        const facebook = this.querySelector('[data-share-channel="facebook"]');
        if (facebook) facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

        const x = this.querySelector('[data-share-channel="x"]');
        if (x) x.href = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;

        const email = this.querySelector('[data-share-channel="email"]');
        if (email) email.href = `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
      }
    }
  );
}
